import { render, staticRenderFns } from "./UserAbility.vue?vue&type=template&id=5ef848de&scoped=true"
import script from "./UserAbility.vue?vue&type=script&lang=js"
export * from "./UserAbility.vue?vue&type=script&lang=js"
import style0 from "./UserAbility.vue?vue&type=style&index=0&id=5ef848de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef848de",
  null
  
)

export default component.exports